import i18n from '@/lang/i18n'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { RangeTypeEnum } from '@/modules/RegistryModule/views/editCase/modals/reports-modal-form/reports-modal.model'

export interface DefaultComboOption {
    id: string
    label: string
}

export const getRangeTypes =
    (): DefaultComboOption[] => [
        { id: RangeTypeEnum.CASE_NUMBER, label: i18n.tc('registry.modal.reports.numerical') },
        { id: RangeTypeEnum.REQUEST_DATE, label: i18n.tc('diagnosis.grid.caseGrid.casRequestDate') },
        { id: RangeTypeEnum.REGISTRY_DATE, label: i18n.tc('diagnosis.grid.caseGrid.casRegistrationDate') },
        { id: RangeTypeEnum.INFORMED_DATE, label: i18n.tc('diagnosis.grid.caseGrid.casInformedDate') },
        { id: RangeTypeEnum.VALIDATED_DATE, label: i18n.tc('diagnosis.grid.caseGrid.casValidationDate') }
    ]

export interface ReportsModalFormRangeFilterState {
    rangeType?: DefaultComboOption
    startDate: StrictNullable<Date>
    endDate: StrictNullable<Date>
    startNumeric?: string
    endNumeric?: string
    caseType?: Nullable<CommonCaseTypeResponse>
    comboOptions: {
        rangeTypes: DefaultComboOption[]
    }
}
export const initialReportsModalFormRangeFilter =
    (): ReportsModalFormRangeFilterState => ({
        rangeType: getRangeTypes()[0],
        startDate: null,
        endDate: new Date(),
        startNumeric: '',
        endNumeric: '',
        caseType: null,
        comboOptions: {
            rangeTypes: getRangeTypes()
        }
    })
